import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const OurModelPage = lazy(() => import('../pages/our-model/page'));
const InvestorPortalPage = lazy(() => import('../pages/investor-portal/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/our-model',
    element: <OurModelPage />,
  },
  {
    path: '/investor-portal',
    element: <InvestorPortalPage />,
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];

export default routes;